export enum QUERY_KEYS {
  // Payments related queries
  PKG_PAYMENTS = 'pkg-payments',
  // Stats related queries
  STATS = 'stats',
  PACKAGES_STATS = 'packages-stats',
  USER_PACKAGES = 'user-packages',
  PACKAGE_PAYMENTS_SUMMARY = 'package-payments-summary',
  PKG_PRICES = 'pkg-prices',
  BACKOFFICE_USER_PACKAGES = 'backoffice-user-packages',
  PACKAGE = 'package',
  LOGGED_USER = 'logged-user',
  PKGS_BY_FILTER = 'pkgs-by-filter',
  DELAYED_PKGS = 'delayed-pkgs',
  // Package requests related queries
  PACKAGE_REQUESTS = 'package-requests',
  PACKAGE_REQUESTS_FEES = 'package-requests-fees',
  PACKAGE_REQUESTS_STATS = 'package-requests-stats',
  UNITE_PACKAGE = 'unite-packages',
  USER_PACKAGE_REQUESTS = 'user-package-requests',

  // Addresses related queries
  ADDRESSES = 'addresses',
  PLACES_CITIES = 'places-cities',
  PLACES_STREETS = 'places-streets',

  // Affiliate related queries
  AFFILIATE_USER = 'affiliate-user',
  AFFILIATES = 'affiliates',
  AFFILIATE_COUPONS = 'affiliate-coupons',
  COUPONS = 'coupons',
  CAMPAIGNS = 'campaigns',
  CAMPAIGN_ROI = 'campaign-roi',
  CAMPAIGN_NAMES = 'campaign-names',
  CAMPAIGN_DASHBOARD = 'campaign-dashboard',
  MARKETING_INVOICES = 'marketing-invoices',
  MARKETING_AFFILIATE_PACKAGES_UNPAID = 'marketing-affiliate-packages-unpaid',
  MARKETING_AFFILIATE_PACKAGES_DELIVERED = 'marketing-affiliate-packages-delivered',
  AFFILIATE_EMAIL_SETTINGS = 'affiliate-email-settings',
  AFFILIATE_EMAIL_RECIPIENTS = 'affiliate-email-recipients',
  AFFILIATE_EMAIL_PREVIEW = 'affiliate-email-preview',
  AFFILIATE_EMAIL_BROADCASTS = 'affiliate-email-broadcasts',
  AFFILIATE_EMAIL_BROADCAST_RECIPIENTS = 'affiliate-email-broadcast-recipients',
  AFFILIATE_EMAIL_SENDS = 'affiliate-email-sends',
  AFFILIATE_EMAIL_SEND_DETAIL = 'affiliate-email-send-detail',

  // Shipping related queries
  PARCEL_STATUS = 'parcel-status',
  SHIPPING_BATCHES = 'shipping-batches',

  // Currency related queries
  CURRENCY_RATES = 'currency-rates',

  // Warehouse arrivals related queries
  WAREHOUSE_ARRIVALS_STATS = 'warehouse-arrivals-stats',

  // Popular brands related queries
  POPULAR_BRANDS = 'popular-brands',

  // Pickup orders related queries
  PICKUP_ORDERS = 'pickup-orders',
  USER_PICKUP_ORDERS = 'user-pickup-orders',

  // Credit related queries
  USER = 'user',
  SERVICE_REQS = 'service-reqs',

  // App config related queries
  APP_CONFIG = 'app-config',
  APP_VERSION = 'app-version',
  NATIVE_LIVE_UPDATE = 'native-live-update',
  PICKUP_ORDER_SETTINGS = 'pickup-order-settings',
  DELAY_PACKAGES_EMAIL_SETTINGS = 'delay-packages-email-settings',

  // USA package lookups related queries
  PKG_LOOKUPS = 'usa-pkg-lookups',
  PKG_CASES = 'pkg-cases',
  PKG_CASE_COUNTS = 'pkg-case-counts',
  PKG_CASE_CUSTOMER_PKGS = 'pkg-case-customer-pkgs',
  PKG_CASE_EXISTING = 'pkg-case-existing',

  // Admin data (CRUD) related queries
  ADMIN = 'admin',
  ADMIN_TABLE = 'admin-table',
  ADMIN_SAVED_SQL_QUERIES = 'admin-saved-sql-queries',

  // Audit log related queries
  AUDIT_LOGS = 'audit-logs',

  // Finance (micro P&L / macro cash flow) related queries
  FINANCE_SETTINGS = 'finance-settings',
  FINANCE_SETTINGS_META = 'finance-settings-meta',
  FINANCE_LAST_MILE_TIERS = 'finance-last-mile-tiers',
  FINANCE_MICRO_SUMMARY = 'finance-micro-summary',
  FINANCE_MICRO_PACKAGES = 'finance-micro-packages',
  FINANCE_MACRO_DASHBOARD = 'finance-macro-dashboard',
  FINANCE_CASH_FLOW = 'finance-cash-flow',
  FINANCE_CASH_FLOW_CATEGORIES = 'finance-cash-flow-categories',
}
